import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import AddPOSMachine from "./components/addPOSMachine";
import { AppSearchSelect } from "../../../components/appComponents";
import { SearchTypeEnum } from "../../../constants/appConstant";
import { useNavigate } from "react-router-dom";

const POSMachines = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);
  const [isActive, setIsActive] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, [isActive]);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open]);

  const getData = async () => {
    setLoading(true);
    const payload = {
      pageNumber: 1,
      recordsToDisplay: 1000,
      isactive: isActive,
    };
    const response = await Common.ApiService.getInstance().request(
      "GetPOSMachines",
      payload,
      "POST"
    );

    const list =
      Array.isArray(response?.data) && response.data.length > 0
        ? response.data[0]?.data ?? []
        : [];

    const responseData = list.map((item) => ({
      ...item,
      isactive: item.isactive ? "Yes" : "No",
    }));
    setData(responseData);
    setLoading(false);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this POS Machine?",
      "Delete POS Machine"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeletePOSMachine?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData();
      }, 500);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _onNavigateToGLFields = () => {
    navigate("/app/posmachines/gl-fields");
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Code", type: "text", isVisible: true, key: "code" },
    { title: "Is Active", type: "boolean", isVisible: true, key: "isactive" },
  ];

  const statusOptions = [
    { id: null, name: "All" },
    { id: true, name: "Active" },
    { id: false, name: "Inactive" },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="md:grid md:grid-cols-5 gap-3 space-y-6 md:space-y-0 mb-4">
        <AppSearchSelect
          value={isActive}
          onChange={setIsActive}
          placeholder={"Select Status"}
          label={"Status"}
          data={statusOptions}
          className={"mb-5 col-span-1"}
        />
      </div>

      <AdvanceTable
        title={"POS Machines"}
        columns={_thead.filter((item) => item.isVisible)}
        data={{ data: data }}
        getData={getData}
        addButton={() => (
          <AddPOSMachine
            id={refId}
            onClose={() => getData()}
            open={open}
            setOpen={setOpen}
          />
        )}
        showPagination={false}
        showAddButton
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
        search={SearchTypeEnum.Local_Search}
        searchInputClassName="custom-search-mobile "
      />
    </>
  );
};

export default POSMachines;
